import { render, staticRenderFns } from "./resource.vue?vue&type=template&id=5ac6483b&scoped=true&"
import script from "./resource.vue?vue&type=script&lang=js&"
export * from "./resource.vue?vue&type=script&lang=js&"
import style0 from "./resource.vue?vue&type=style&index=0&id=5ac6483b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac6483b",
  null
  
)

export default component.exports